import React, { useEffect, useRef } from 'react'
import Model from 'components/model'

interface IProps {
  closeTime?: number
  onHide: () => any
  show: boolean
  children: any
}

function Message ({ closeTime, onHide, show, children }: IProps) {
  const timmer = useRef<any>(null)

  useEffect(() => {
    if (show && closeTime) {
      timmer.current = setTimeout(() => {
        onHide()
      }, closeTime)
    }

    return () => {
      clearTimeout(timmer.current)
    }
  }, [closeTime, onHide, show])

  return (
    <Model
      onHide={onHide}
      show={show}
    >
      {children}
    </Model>
  )
}

export default Message
